import { IAppServices } from '../domain/slide-app/core/interfaces/app-service.interface';
import { SlideDataServices } from '../domain/slide-app/core/slide-data-services.core';
import { EditEvents } from '../domain/slide-app/core/interfaces/event.interface';

export class AppServiceProvider {
    private static instance: AppServiceProvider;

    public static getInstance(): AppServiceProvider {
        if (!AppServiceProvider.instance) {
            AppServiceProvider.instance = new AppServiceProvider();
        }
        return AppServiceProvider.instance;
    }

    private editServicesHasLoad = false;
    private appServices: IAppServices;

    public waitForReady(callback: (appService: IAppServices) => void): void {
        if (this.editServicesHasLoad) {
            callback(this.appServices);
            return;
        }
        SlideDataServices.EventManager()?.on(EditEvents.AppServiceProviderLoaded, callback);
    }

    public getAppServices(): IAppServices {
        return this.appServices;
    }

    /**
     * 入口处初始化
     * @param appServices
     */
    public initWithAppServices(appServices: IAppServices): void {
        if (!this.appServices) {
            this.appServices = appServices;
            this.appServices.init();
        } else {
            window.log.error('app services instance has bind!');
        }
        this.editServicesHasLoad = true;
        SlideDataServices.EventManager()?.emit(
            EditEvents.AppServiceProviderLoaded,
            this.appServices,
        );
    }
}
